module.exports = new __parcel__URL__("open-all-button.7b28754b.wav").toString();